import { ReactNode } from 'react';
import AppModal from '@common/ui/AppModal';
import PrimarySecondary from '@common/ui/PrimarySecondary';
import { MaterialIcon } from '@components';
import { Code } from '@components/Markdown/Code';
import { LoadingButton } from '@mui/lab';
import { Alert, Stack, Tab, Tabs, Typography } from '@mui/material';

interface AssessmentReportRevokeModalProps {
  open: boolean;
  isSelectedItems: boolean;
  onClose: () => void;
  onExportCSV: () => void;
  exportLoading?: boolean;
  actions?: ReactNode;
}

const script = AWS_CLI_SCRIPT || '';

export default function AssessmentReportRevokeModal({
  open,
  onClose,
  exportLoading,
  onExportCSV,
  isSelectedItems,
  actions,
}: AssessmentReportRevokeModalProps) {
  return (
    <AppModal open={open} onClose={onClose} header="Revoke standing access" width={600}>
      <Stack spacing={2} direction="column">
        <Alert severity="info" variant="outlined">
          <Typography variant="body2">
            After revoking access in AWS, click Reassess to view the changes and see your improved your access posture.
          </Typography>
        </Alert>
        <Tabs value="aws-cli">
          <Tab label="AWS CLI" value="aws-cli" />
          <Tab label="Terraform (coming soon)" value="terraform" disabled />
        </Tabs>
        <Typography variant="body2">Use this script to revoke access to permission sets</Typography>
        <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center">
          <PrimarySecondary primary="Download the entitlements list" secondary="Step 1:" inverse />{' '}
          <LoadingButton
            onClick={onExportCSV}
            variant="text"
            startIcon={<MaterialIcon symbol="download" />}
            loading={exportLoading}
            size="small"
            disabled={!isSelectedItems}
          >
            Download CSV
          </LoadingButton>
        </Stack>
        <Stack spacing={1} direction="column">
          <PrimarySecondary primary="Copy the following script into your AWS CLI:" secondary="Step 2:" inverse />
          <Code withWhitespaces language="bash">
            {script}
          </Code>
        </Stack>
        <PrimarySecondary
          primary="Run the script with Administrator permissions and provide the CSV as input"
          secondary="Step 3:"
          inverse
        />
        {actions}
      </Stack>
    </AppModal>
  );
}
